<p>
  vehicle-model-detail works!
</p>
